<template>
    <span :class="['icon', name]"
          :style="styleObject">
    </span>
</template>

<script type="text/babel">

export default {
    name: 'Icon',
    props: {
        name: {
            type: String,
            required: true
        },
        color: {
            type: String,
            default: '#fff'
        },
        fontSize: {
            type: String,
            default: '1.5em'
        },
        rotate: {
            type: Boolean,
            default: false
        },
        rotateValue: {
            type: Number,
            default: 90
        }
    },
    computed: {
        styleObject () {
            return {
                color: this.color,
                fontSize: this.fontSize,
                transform: this.rotate ? `rotate(${this.rotateValue}deg)` : ''
            };
        }
    }
};

</script>

